
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Whether the product supports bullet points in the search results.`}</p>
    <p>{`When false, `}<inlineCode parentName="p">{`SearchBulletPoint`}</inlineCode>{` `}<a parentName="p" {...{
        "href": "/schema/named-type/PositionFormattedDescription",
        "title": "A formatted description of the position profile"
      }}><inlineCode parentName="a">{`PositionFormattedDescription`}</inlineCode></a>{`s will be silently discarded.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;